import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/nav.scss";
import ReactTooltip from "react-tooltip";
import parse from "../parse";

class Question extends React.Component {
  constructor(props) {
    super(props);
    this.answerSelected = this.answerSelected.bind(this);
  }

  answerSelected(selection) {
    if (this.props.question.type === "button") {
      var figure = this.props.question.figure;
      this.props.answerSelected(figure);
      return;
    } else if (this.props.question.type === "vbutton") {
      this.props.answerSelected(
        this.props.question.id,
        true,
        selection.target.id
      );
      return;
    }
    let answer = null;
    if (
      this.props.question.type === "choice" ||
      this.props.question.type === "dchoice"
    ) {
      answer = selection.target.innerText;
    } else if (selection.target.innerText === "Yes") {
      answer = true;
    } else {
      answer = false;
    }
    this.props.answerSelected(
      this.props.question.id,
      answer,
      selection.target.id
    );
  }

  selection(choice) {
    if (
      this.props.question.type === "choice" ||
      this.props.question.type === "dchoice"
    ) {
      if (this.props.currentSelection === choice.text) {
        return true;
      }

      if (typeof(choice.value) !== 'undefined') {
        return (choice.value + '') === this.props.currentSelection;
      }
      return false;
    } else {
      if (this.props.currentSelection === true) {
        return choice.text === "Yes";
      } else if (this.props.currentSelection === false) {
        return choice.text === "No";
      } else {
        return false;
      }
    }
  }

  render() {
    let choices;
    const question = this.props.question;
    const type = question.type;
    if (type === "button") {
      return (
        <div className="card management transparent">
          <button
            id={question.id}
            className="btn btn-primary management"
            onClick={this.answerSelected}
          >
            {question.text}
          </button>
        </div>
      );
    } else if (type == "vbutton") {
        return (
          <div className="card management transparent">
            <button
              id={question.id}
              className="btn btn-primary management"
              onClick={this.answerSelected}
            >
              {question.text} &gt;
            </button>
          </div>
        );
    } else if (type === "choice" || type === "dchoice") {
      choices = this.props.question.choices;
    } else {
      choices = [{ text: "Yes" }, { text: "No" }];
    }

    const choicesClasses =
      choices.length > 2
        ? "segmented-options-vertical segmented-options-vertical-" +
          choices.length
        : "segmented-options-" + choices.length;

    return (
      <div className="question">
        {this.props.question.text ? parse(this.props.question.text) : null}
        <div className={"segmented-options " + choicesClasses}>
          {choices.map((choice, i) => (
            <label
              onClick={this.answerSelected}
              className={
                this.selection(choice) ? "selected " + this.props.tab : ""
              }
              id={choice.value}
            >
              <b id={choice.value}>{choice.text}</b>
              {choice.info ? (
                <div className="info">
                  <a
                    onClick={this.displayInfo}
                    className="info-i"
                    data-tip={choice.info}
                  >
                    {String.fromCharCode(9432)}
                  </a>
                  <ReactTooltip place="top" type="light" effect="float" />
                </div>
              ) : null}
            </label>
          ))}
        </div>
      </div>
    );
  }
}

export default Question;
